export default {
  data() {
    return {
      errors: [],
    };
  },
  methods: {
    getError(path) {
      const error = this.errors.find((err) => err.path === path);
      if (error) {
        return error.message;
      }
      return undefined;
    },
    setError(path, message) {
      this.errors.push({ path, message });
    },
    setErrors(errors) {
      this.errors = errors;
    },
    clearErrors() {
      this.errors = [];
    },
  },
};
